export const SlovenianCurrencyMixin = {
  methods: {
    formatPrice (price) {
      const slovenianFormatter = new Intl.NumberFormat('sl-SI', {
        style: 'currency',
        currency: 'EUR'
      })
      return slovenianFormatter.format(price)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Helpers/NumberFormatMixin.js